// "Delivering to <requester> (<role>)": the purchase manager sends a purchase
// request on to the person who raised it. It is the existing store step of
// pending -> ordered -> delivered_store -> delivered_balagruha, so from there
// the requester marks it Delivered to Balagruha as before (UpdatePurchaseStatusModal).
import { updatePurchaseRequestStatus } from '../../../api';

export const DELIVERING_STATUS = 'delivered_store';

// The purchase manager can only move a request on from these; the backend
// allows pending -> ordered -> delivered_store one step at a time.
export const DELIVERING_FROM_STATUSES = ['pending', 'ordered'];

// "purchase-manager" -> "Purchase Manager"
export const formatRole = (role) =>
    (role || '')
        .toString()
        .split('-')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

// "Asmi Shinde (Coach)", or null when the request has no requester name. The
// role is the one it was raised in; older requests only have the requester's
// current role.
export const requesterWithRole = (request) => {
    const name = request?.requestedBy?.name || request?.requestedByName;
    if (!name) return null;
    const role = formatRole(request.requestedByRole || request.requestedBy?.role);
    return role ? `${name} (${role})` : name;
};

// What the requester's count is about (coach / medical incharge): their
// requests on the way to them, waiting to be marked Delivered to Balagruha.
export const awaitingDeliveryOf = (requests = []) =>
    requests.filter((request) => request.status === DELIVERING_STATUS);

export const deliveringLabel = (request) => {
    const requester = requesterWithRole(request);
    return requester ? `Delivering to ${requester}` : 'Delivering to Requester';
};

const errorText = (error) => error?.response?.data?.message || error?.message || 'Failed to update status';

// Moves a pending / ordered request to Delivering. Returns
// { success, changed, message }: `changed` is true when at least one step was
// saved (a pending request can stop at 'ordered' if the second step fails).
export async function markDelivering(request, note = '') {
    const label = deliveringLabel(request);
    const steps = request.status === 'pending' ? ['ordered', DELIVERING_STATUS] : [DELIVERING_STATUS];
    let changed = false;

    for (const status of steps) {
        const notes =
            status === DELIVERING_STATUS ? (note ? `${label} - ${note}` : label) : 'Ordered by Purchase Manager';
        try {
            const response = await updatePurchaseRequestStatus(request._id, { status, notes });
            if (!response?.success) return { success: false, changed, message: response?.message || 'Failed to update status' };
        } catch (error) {
            return { success: false, changed, message: errorText(error) };
        }
        changed = true;
    }
    return { success: true, changed };
}
